__turbopack_context__.v({
  "answer": "faq-section-module___Ijs1q__answer",
  "arrow": "faq-section-module___Ijs1q__arrow",
  "caption": "faq-section-module___Ijs1q__caption",
  "content": "faq-section-module___Ijs1q__content",
  "faq": "faq-section-module___Ijs1q__faq",
  "ghost": "faq-section-module___Ijs1q__ghost",
  "icon": "faq-section-module___Ijs1q__icon",
  "item": "faq-section-module___Ijs1q__item",
  "list": "faq-section-module___Ijs1q__list",
  "photos": "faq-section-module___Ijs1q__photos",
  "question": "faq-section-module___Ijs1q__question",
  "services": "faq-section-module___Ijs1q__services",
  "surface": "faq-section-module___Ijs1q__surface",
});
